import { SelectOption } from '@anm/components/select/Select/index';
import { useCallback, useState } from 'react';

import { SelectProps } from '.';

const getInitialState = ({ values, controlValue }: SelectProps) =>
  values.filter(v => v.value === controlValue)[0] || values[0];

const useCustomizationFormSelect = (props: SelectProps) => {
  const { onChange, id } = props;
  const [selectValue, setSelectValue] = useState(getInitialState(props));

  const handleSelectChange = useCallback(
    (value: SelectOption) => {
      setSelectValue(value);
      onChange({ id, value: value.value });
    },
    [id]
  );

  return [selectValue, handleSelectChange] as const;
};

export default useCustomizationFormSelect;
